__turbopack_context__.v({
  "className": "herodisplay_e2c1ff8-module__vyHj3W__className",
});
